// Copyright ©️ 2026 eVolve MEP, LLC

import { FLAT_BLACK_FILLER, FLAT_WHITE_FILLER } from '@evolvemep/api-ts';

import cloudSvg from 'assets/icons/icon-src/markup/cloud.svg?raw';
import {
  BaseMarkupTool,
  type MarkupToolContext,
  type PanelConfig,
} from 'components/Autodesk/extensions/MarkupModeExtension/BaseMarkupTool';

const { Autodesk } = window;

export class CloudTool extends BaseMarkupTool {
  readonly type = 'cloud'; // Matches the existing type used by Autodesk's cloud markup tool, which we build on top of.

  constructor(context: MarkupToolContext) {
    super(context, {
      strokeWidth: 2,
      strokeColor: FLAT_BLACK_FILLER,
      strokeOpacity: 100,
      fillColor: FLAT_WHITE_FILLER,
      fillOpacity: 50,
    });
  }

  protected getPanelConfig(): PanelConfig {
    return {
      panelTitle: 'Cloud',
      sections: [
        {
          heading: 'Outline',
          fields: [
            { property: 'stroke-width', label: 'Size' },
            { property: 'stroke-color', colorLabel: 'Color', opacityLabel: 'Opacity' },
          ],
        },
        {
          heading: 'Fill',
          fields: [{ property: 'fill-color', colorLabel: 'Color', opacityLabel: 'Opacity' }],
        },
      ],
    };
  }

  protected activateEditMode() {
    const cloudEditMode = new Autodesk.Viewing.Extensions.Markups.Core.EditModeCloud(this.markupExtension);
    this.markupExtension.changeEditMode(cloudEditMode);
  }

  protected readonly buttonIcon = cloudSvg;
  protected readonly buttonTooltip = 'Cloud';
}
